import { Button, makeStyles, mergeClasses, Tooltip } from "@fluentui/react-components";

import { ChevronLeft12Regular, ChevronRight12Regular } from "@fluentui/react-icons";
import { useDeviceDrawerStore } from "../../store/DeviceDrawerStore";

const useStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
        width: "100%",
    },
    navWrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px",
    },
    navBtn: {
        minWidth: "8px",
        padding: 0,
        minHeight: "8px",
    },
    navDisabledBtn: {
        minWidth: "16px"
    }
});

type FormNavProps = {
    totalSteps: number;
};

export default function FormNav({ totalSteps }: FormNavProps) {
    const styles = useStyles();
    const { level, next, previous, setLevel } = useDeviceDrawerStore();

    return (
        <div className={styles.root}>
            <Tooltip content="Previous" relationship="label">
                <Button
                    icon={<ChevronLeft12Regular />}
                    appearance="subtle"
                    shape="circular"
                    onClick={previous}
                    disabled={level <= 1}
                />
            </Tooltip>

            <div className={styles.navWrapper}>
                {Array.from({ length: totalSteps }, (_, i) => (
                    <Button
                        className={level === i + 1 ? mergeClasses(styles.navBtn, styles.navDisabledBtn) : styles.navBtn}
                        key={i}
                        appearance="primary"
                        shape="circular"
                        onClick={() => setLevel(i + 1)}
                        disabled={level === i + 1}
                    />
                ))}
            </div>

            <Tooltip content="Next" relationship="label">
                <Button
                    icon={<ChevronRight12Regular />}
                    appearance="subtle"
                    shape="circular"
                    onClick={next}
                    disabled={level >= totalSteps}
                />
            </Tooltip>
        </div>
    )
}